module.exports = __webpack_public_path__ + "img/relbase_logo.9192540f.webp";